import { motion } from "motion/react";
import { builtWith } from "../lib/landingData";
import { BrandLogo } from "../components/BrandLogo";
import { Rocket, Code2 } from "lucide-react";
import { DevinWindsurfLogo } from "../components/DevinWindsurfLogo";

const iconMap = {
  Rocket: Rocket,
  Code2: Code2,
} as const;

const customIconMap = {
  "Devin | Windsurf": DevinWindsurfLogo,
} as const;

export function BuiltWithSection() {
  return (
    <section className="relative py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 h-[400px] w-[600px] bg-primary/10 rounded-full blur-[150px] pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-foreground mb-4">
            Crafted with modern tools
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            This product was designed, coded, and shipped using some of the most advanced creative tools on the planet.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="flex flex-wrap items-center justify-center gap-4"
        >
          {builtWith.map((brand) => {
            const CustomIcon = brand.icon
              ? iconMap[brand.icon as keyof typeof iconMap]
              : (customIconMap[brand.name as keyof typeof customIconMap] as React.ComponentType<{ className?: string }> | undefined);
            return (
              <BrandLogo
                key={brand.name}
                name={brand.name}
                slug={brand.slug}
                icon={CustomIcon}
                iconColor={brand.iconColor}
              />
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
